export const FormLabel = {
  baseStyle: {
    mb: '1',
    fontSize: 'sm',
    fontFamily: 'body',
    fontWeight: '400',
    color: 'font.ink',
  },
};
